import { render } from "./Header.vue?vue&type=template&id=c2645e16&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=c2645e16&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c2645e16"

export default script